module.exports = function UpdateTopicRequest(path, update) {
    this.path = path;
    this.update = update;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-request.js
// module id = 503
// module chunks = 1